/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/capital_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="30" cy="30" r="2"/><circle pid="1" cx="2" cy="30" r="2"/><circle pid="2" cx="30" cy="2" r="2"/><circle pid="3" cx="2" cy="2" r="2"/><path pid="4" d="M16 2L4 9v14l12 7 12-7V9L16 2zm2 25h-4v-1h4v1zm8-4l-5-1V11l-1-1v12.945l4.049.81-.098.49-4.158-.831L19 25h-1v-5h-1v1h-2v-1h-1v5h-1l-.793-1.586-4.158.831-.098-.49 4.049-.81V10l-1 1v11l-5 1 2.903-7.743-3.08-3.08.354-.354 2.92 2.92L12 7v3l1-1V5h1v13h1v-4l.5-1V9h1v4l.5 1v4h1V5h1v4l1 1V7l2.902 7.743 2.92-2.92.355.354-3.08 3.08L26 23z"/><g><path pid="5" d="M16 32.076L2 24.037V7.965L16-.076l14 8.041v16.072l-14 8.039zM3 23.459l13 7.465 13-7.465V8.543L16 1.076 3 8.543v14.916z"/></g>'
  }
})
